/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import FreeUsersImageUploader from './free-users-image-uploader.service';
import PaidUsersImageUploader from './paid-users-image-uploader.service';

export { FreeUsersImageUploader, PaidUsersImageUploader };
